export const ROUTES = {
    VALIDATION: {
        INDEX: '/validation',
        HIERARCHY: '/validation/files/:id',
        VALIDATE: '/validation/projects/:projectId/validate/:solutionId'
    },
    ESTIMATION: {
        INDEX: '/',
        LEGACY: '/estimationLegacy'
    },
    USERS: {
        INDEX: '/users'
    }
};
